<template>
  <div class="index_ui">
    <Breadcrumb></Breadcrumb>
    <div class="upload-box">
      <el-upload v-show="!showProgress" class="upload-demo" ref="upload" drag action="" multiple :show-file-list='false' :file-list="fileList" :auto-upload="false" :on-preview="handpreview" :on-change="handchange" >
        <van-icon name="add-o" />
        <div class="el-upload__text" style="color:#444;">将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__text " style="color:#999999;">（单个视频文件容量不超过1GB,其他单个文件容量不超过50M)</div>

      </el-upload>
      <div class="upload-Progress" v-show="showProgress">
        <el-progress v-if="percentage!=100" :text-inside="true" :stroke-width="28" :percentage="percentage"></el-progress>
        <el-progress v-else :text-inside="true" :stroke-width="28" :percentage="percentage" status="success"></el-progress>
        <p class="upload_text">{{percentage==100?'上传完成！':'资源上传中…'}}</p>
      </div>
    </div>
    <div class="upload-list">
      <el-row class="top">
        <el-col class="col-5">
          <div class="text-left">资源编号</div>
        </el-col>
        <el-col class="col-23">
          <div>资源名称
            <span class="red">*</span>
          </div>
        </el-col>
        <el-col class="col-8">
          <div>大小</div>
        </el-col>
        <el-col class="col-11">
          <div>资源类别</div>
        </el-col>
        <el-col class="col-11">
          <div>资源类型</div>
        </el-col>
        <el-col class="col-11">
          <div>关联学科
            <span class="red">*</span>
          </div>
        </el-col>
        <el-col class="col-17">
          <div>资源标签</div>
        </el-col>
        <el-col class="col-10">
          <div>开放范围
            <span class="red">*</span>
          </div>
        </el-col>
        <el-col class="col-4">
          <div>操作</div>
        </el-col>
      </el-row>
      <el-row v-for="(item,i) in fileList" :key="item.uid">
        <el-col class="col-5">
          <div class="text text-left">{{item.uid}}</div>
        </el-col>
        <el-col class="col-23">
          <div>
            <el-input class="inputName" v-model="item.nameNew" placeholder="请输入内容" ></el-input>.{{item.nameType}}</div>
        </el-col>
        <el-col class="col-8">
          <div class="text">{{getSize(item.size)}}</div>
        </el-col>
        <!-- 资源类别 -->
        <el-col class="col-11">
          <div>
            <el-cascader class="upSelect" expand-trigger="hover" :options="resourceTypeId1List" v-model="item.resourceTypeId1" @change="handleChange(item,i)">
            </el-cascader>
          </div>
        </el-col>
        <!-- 资源类型 -->
        <el-col class="col-11">
          <div>
            <el-cascader class="upSelect" expand-trigger="hover" :options="resourceTypeId2List" v-model="item.resourceTypeId2" @change="handleChange2(item,i)">
            </el-cascader>
          </div>
        </el-col>
        <!-- 关联学科 -->
        <el-col class="col-11">
          <div>
            <el-select class="upSelect" v-model="item.resourceSubjectId" placeholder="请选择" @change="changeSubject(item,i)">
              <el-option v-for="item in resourceSubjectList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <!-- 资源标签 -->
        <el-col class="col-17">
          <div>
            <el-input class="inputLabel"  v-model="item.labelNew" placeholder="标签" @change="changelabel(item,i)"></el-input>
          </div>
        </el-col>
        <!-- 开放范围 -->
        <el-col class="col-10">
          <div>
            <el-select class="upSelect" v-model="item.openCondition" placeholder="请选择" @change="changeCondition(item,i)">
              <el-option v-for="item in openConditionList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col class="col-4">
          <div>
            <el-button type="text" @click="removeItem(item)">删除</el-button>
          </div>
        </el-col>
      </el-row>
      <div v-if="fileList==0">
          <img style="margin-top:100Px;" src="@/assets/no_img.png" alt="">
      </div>
    </div>
    <div class="footer_btn" >
      <a href="javascript:;" class="upLoad_btn back" @click="goback">返回</a>
      <a href="javascript:;" class="upLoad_btn_background submit" @click="submitUpload">提交</a>
    </div>
  </div>
</template>

<script>
import { listResourceSubject, listResourceType, listLabel } from '@/api/common_api'

import moment from 'dayjs'
import { mapActions, mapState } from 'vuex'
import {
  Icon
} from 'vant';
import axios from 'axios'
import { Breadcrumb } from '@/components'

export default {
  components: {
    [Icon.name]: Icon,
    Breadcrumb
  },
  data() {
    return {
      showProgress: false,
      percentage: 0,
      fileList: [],
      options: [
        { value: '默认类别', label: '默认类别' }
      ],
      defaultConfig: {
        resourceTypeId1: '',
        resourceTypeId2: '',
        resourceSubjectId: '',
        label: '',
        openCondition: ''
      },
      resourceSubjectList: [],
      resourceTypeId1List: [],
      resourceTypeId2List: [],
      labelList: [],
      openConditionList: [

        {
          value: 2,
          label: '匿名可见'
        },
        {
          value: 1,
          label: '登录可见'
        },
      ]
    };
  },
  created() {
    this.getList()
  },
  computed: {
    getSize() {
      return function (value) {
        var fileSizeByte = value;
        var fileSizeMsg = "";
        if (fileSizeByte < 1048576) fileSizeMsg = (fileSizeByte / 1024).toFixed(2) + "KB";
        else if (fileSizeByte == 1048576) fileSizeMsg = "1MB";
        else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) fileSizeMsg = (fileSizeByte / (1024 * 1024)).toFixed(2) + "MB";
        else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) fileSizeMsg = "1GB";
        else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) fileSizeMsg = (fileSizeByte / (1024 * 1024 * 1024)).toFixed(2) + "GB";
        else fileSizeMsg = "文件超过1TB";
        return fileSizeMsg;
      }
    },
  },
  methods: {
    ...mapActions([
      'increment'
    ]),
    goback(){
      this.$router.go(-1);
    },
    getTree(data) {
      let _this = this
      data.value = data.id;
      data.label = data.name
      if (data.show_children) {
        data.children = data.show_children;
        for (var i = 0; i < data.show_children.length; i++) {
          if (data.show_children[i]) {
            _this.getTree(data.show_children[i])
          }
        }
      }
      return data
    },
    handleChange(item, i) {
      if (i == 0) {
        this.defaultConfig.resourceTypeId1 = item.resourceTypeId1
      }
    },
    handleChange2(item, i) {
      if (i == 0) {
        this.defaultConfig.resourceTypeId2 = item.resourceTypeId2
      }
    },
    changeSubject(item, i) {
      if (i == 0) {
        this.defaultConfig.resourceSubjectId = item.resourceSubjectId
      }
    },
    changelabel(item, i) {
      if (i == 0) {
        this.defaultConfig.labelNew= item.labelNew
        this.defaultConfig.label = item.label
      }
    },
    changeCondition(item, i) {
      if (i == 0) {
        this.defaultConfig.openCondition = item.openCondition
      }
    },
    getList() {
      let _this = this
      listResourceSubject().then(function (res) {
        if (res.s == 1) {
          _this.resourceSubjectList = res.d
          // _this.edit()
        }
      })
      listResourceType({ type: 1 }).then(function (res) {
        if (res.s == 1) {
          res.d.forEach((element, i) => {
            element = _this.getTree(element)
          });
          _this.resourceTypeId1List = res.d
        }
      })
      listResourceType({ type: 2 }).then(function (res) {
        if (res.s == 1) {
          res.d.forEach((element, i) => {
            element = _this.getTree(element)
          });
          _this.resourceTypeId2List = res.d
        }
      })
      listLabel().then(function (res) {
        if (res.s == 1) {
          _this.labelList = res.d
        }
      })
    },
    edit() {

      let _this = this
      let obj = {
        data: {
          arr: _this.resourceSubjectList
        }
      }
      obj.data = JSON.stringify(obj.data)
      updateResourceSubject(obj).then(function (res) {
        if (res.s == 1) {

        }
      })
    },
    handpreview() {
   
    },
    beforeAvatarUpload(file) {
      // 匹配 视频
      var result = '';
      var videolist = ['mp4', 'm2v', 'mkv'];
      result = videolist.some(function (item) {
        return item == file.type.split('/')[1];
      });
      if (result) {
        result = 'video';
      }else{
        result = 'other';
      }
    
      if(result=='video'){
        var isLt2M = (file.size / (1024 * 1024)).toFixed(2)>1000;
         if (isLt2M) {
          this.$message.error('视频大小不能超过 1GB!');
        }
      }else{
        var isLt2M = (file.size / (1024 * 1024)).toFixed(2)>50;
         if (isLt2M) {
          this.$message.error('资源文件大小不能超过 50MB!');
        }
      }
  
      return isLt2M;
    },
    handchange(file, fileList) {
      var _this = this

      fileList.forEach((element, i) => { 
      
        if (element.nameNew) {
          element.name = element.nameNew + '.' + element.nameType
        } else {
          if (i == 0) {
            _this.$set(element, 'resourceSubjectId', _this.resourceSubjectList[0].id)
            _this.$set(element, 'openCondition', _this.openConditionList[0].value)
            _this.defaultConfig.resourceSubjectId = _this.resourceSubjectList[0].id
            _this.defaultConfig.openCondition = _this.openConditionList[0].value
          } else {
            _this.$set(element, 'resourceTypeId1', _this.defaultConfig.resourceTypeId1)
            _this.$set(element, 'resourceTypeId2', _this.defaultConfig.resourceTypeId2)
            _this.$set(element, 'resourceSubjectId', _this.defaultConfig.resourceSubjectId)
            _this.$set(element, 'label', _this.defaultConfig.label)
            _this.$set(element, 'openCondition', _this.defaultConfig.openCondition)
          }
          _this.$set(element, 'nameNew', element.name.split('.')[0])
          let arr=element.name.split('.')
          element.nameType = arr[arr.length-1]
        }
        
        if(_this.beforeAvatarUpload(element.raw)){
          fileList.splice(i, 1)
        }
      });

      this.fileList = fileList
      this.increment({ count: fileList.length });
    },
    removeItem(item) {
      let _this = this
      this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.fileList.forEach((element, i) => {
          if (element.uid == item.uid) {
            _this.fileList.splice(i, 1)
          }
        });
        _this.increment({ count: _this.fileList.length });
        _this.$message({
          type: 'success',
          message: '删除成功!'
        });

      }).catch(() => {

      });

    },
    async getAduitNodeData(paramsList) {
      let resNodeIdParams = [];
      let _this=this
      let num = 0
      let tatol=paramsList.length
      const promises = paramsList.map(file => {
        

          if(file.labelNew){
            file.label=file.label+','+file.labelNew
          }
          
          file.name = file.nameNew + '.' + file.nameType
          if (file.resourceTypeId1 && file.resourceTypeId1.length > 0) {
            file.resourceTypeId1 = file.resourceTypeId1[file.resourceTypeId1.length - 1]
          }
          if (file.resourceTypeId2 && file.resourceTypeId2.length > 0) {
            file.resourceTypeId2 = file.resourceTypeId2[file.resourceTypeId2.length - 1]
          }
          //new 一个FormData格式的参数
          let params = new FormData()
          params.append('files', file.raw)
          params.append('name', file.name);
          params.append('size', file.size);
          if( file.label){
            params.append('label', file.label);
          }
          if( file.openCondition){
            params.append('openCondition', file.openCondition);
          }
          if( file.resourceSubjectId){
            params.append('resourceSubjectId', file.resourceSubjectId);
          }
          if( file.resourceTypeId1){
            params.append('resourceTypeId1', file.resourceTypeId1);
          }
          if( file.resourceTypeId2){
            params.append('resourceTypeId2', file.resourceTypeId2);
          }
          let _this = this
          let config = {
            baseURL: process.env.VUE_APP_BASE_API,
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: progressEvent => {
              var n=(num/tatol)*100
              var complete =((progressEvent.loaded / progressEvent.total)/tatol * 100)+n | 0;

                _this.percentage = complete;
            
            }
          }

          return new Promise((resolve, reject) => {
              //把 uploadUrl 换成自己的 上传路径
              axios.post('/resource/modifyResource.ajax', params, config).then(res => {
                  if (res && res.data && res.data.s === 1) { //如果为真 resolve出去
                   num++
                      resolve(res.data)
                  } else {
                      reject(res)
                  }
              }).catch(err => {
                
                  reject(err)
              });
          })
      });
      
      const temp = await Promise.all(promises).then(res =>{
         if (_this.percentage == 100) {
            _this.$message({
              message: "上传完毕",
              type: 'success'
            });
            setTimeout(function () {
              _this.fileList = []
              _this.percentage = 0
              _this.increment({ count: 0 });
              _this.showProgress = false
            //  _this.$router.push({ path: '/resourceManage', query: {} })
            }, 1000);

          }
      }).catch(console.error)
      
    },
    submitUpload() {
      let _this = this
     
      this.$confirm('是否完成编辑并保存', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.fileList.forEach( element => {
          if (element.nameNew == '' || element.nameNew == undefined) {
            _this.$message({
              message: "请输入资源名称",
              type: 'error'
            });
            return false
          }
          _this.showProgress = true
        });
        _this.getAduitNodeData(_this.fileList)
        
        

      }).catch(() => {

      });

    }
  }
};
</script>

<style lang="less" scoped>
.index_ui {
  width: 100%;
  height: 1052Px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0Px 2Px 4Px 0Px rgba(235, 235, 235, 0.5);
  padding:0 14Px;
  box-sizing: border-box;
  font-size:14Px;
  .upload-box{
    margin-top:12Px;
  }
  .upload-Progress {
    height: 160Px;
    background: #f4f8fe;
    position: relative;
  
    .el-progress {
      width: 262Px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .upload_text {
      color: #444444;
      text-align: center;
      position: absolute;
      top: 75%;
      left: 52%;
      transform: translate(-75%, -52%);
    }
  }
  .upload-list {
    margin-top: 27Px;
    text-align: center;
    min-height: 600Px;
    overflow-y: auto;
    .top {
      color: #191919;
      
    }
    .red {
      color: #ec3441;
    }
    .el-row {
      color: #444444;
      margin-bottom: 16Px;
      height: 40Px;
      line-height: 40Px;
      .el-button--text {
        padding: 7Px 0;
      }
      .col-5{
        width:7%;
        // min-width:60Px;
      }
      .col-4{
        width:7%;
       
      }
      .col-23{
        width:21%;
        // min-width:270Px;
      }
      .col-8{
        width:8%;
        // min-width:50Px;
      }
      .col-11{
        width:12%;
        // min-width:100Px;
      }
      .col-10{
        width:10%;
        // min-width:100Px;
      }
      .col-17{
        width:10%;
        // min-width:200Px;
      }
    }
  }
  .text-left {
    text-align: left;
    width:100Px;
    overflow:hidden; //超出的文本隐藏
    text-overflow:ellipsis; //溢出用省略号显示
    white-space:nowrap; //溢出不换行
  }
  .inputName {
    width: 170Px;
    margin-right: 5Px;
  }
  .inputLabel {
    width: 75Px;
    margin-right: 5Px;
  }
  .upSelect {
    width: 140Px;
  }
  .upSelect.big {
    width: 200Px;
  }
  .footer_btn {
    text-align: center;
    margin-top: 50Px;
    .back {
      margin-right: 54Px;
    }
  }
  .text {
    line-height: 40Px;
  }
  
}
</style>
